<template>
  <div class="col-xs-6 selectHeader">
    <select
      id="currency-setter"
      :value="currency"
      name="currency-setter"
      class="form-control"
      @change="$event => setCurrency($event.target.value)"
    >
      <option value="PLN">
        PLN
      </option>
      <option value="EUR">
        EUR
      </option>
       <option value="USD">
        USD
      </option>
    </select>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
    computed: {
      ...mapState('currency', ['currency', 'ratio']),
      ...mapState('cart', ['order'])
    },
    watch: {
      currency() {
        this.updateCurrencyInCart();
      }
    },
    methods: {
      ...mapMutations('currency', ['setCurrency']),
      ...mapMutations('cart', ['changePrice']),
      updateCurrencyInCart() {
        this.order.lines.forEach(line => {
          this.changePrice({
            line,
            change: (line.plnPrice / this.ratio).toFixed(2),
            ratio: undefined,
            leaveDiscount: true,
          });
        });
      }
    },
}
</script>
